import { styled } from '@mui/material/styles';
import { QTableCell } from '@kw/quokka-ui';

export const KwTableCell = styled(QTableCell)<{ selected?: boolean }>`
  padding: 18px;
`;
